export default "__VITE_ASSET__cqXLkypQ__"